import React from 'react';
import Page from '../../Components/Page';

const Recipes = () => {
  return (
    <Page className="text-center">
      <h2 className="text-2xl">Recipes</h2>
      <p>I like to make high protien low calorie recipes of popular dishes</p>
      <h3>Coming Soon</h3>
    </Page>
  );
};

export default Recipes;
